import { Flex } from "@chakra-ui/react"

export const CenterContainer = ({children} : { children : React.ReactNode}) => {
    return <Flex w={{base: "100%", md: "1200px"}} pos="relative" maxW="1280px" px={{base: "32px", lg: "0px"}} flexDir="column" margin="0 auto">
        {children}
    </Flex>
}